<template>
  <div class='report-item report-item--graphic brand-background-color' :style='styleOptions'>
    <div :class="['text', config.reverseLayout ? 'reverse' : '']">
      <div class="image-container flex-item">
        <img v-if='this.config.image' :src='this.config.image' class='image' />
        <div v-else class="placeholder"><ion-icon name="image-outline"></ion-icon></div>
      </div>
      <div class='flex-item text-container'>
        <ContentEditable :style='{color: titleColor}' :html='true' class='brand-title-color content-title' tag='h1' :editable='editable' v-model='content.title' :font-scale='titleFontSize' :translated='$t(content.title, "title", this.tag)'></ContentEditable>
        <ContentEditable :style='{color: textColor}' class='content-text brand-text-color' :html='true' tag='div' :editable='editable' v-model='content.text' :font-scale='textFontSize' :translated='$t(content.text, "text", this.tag)'></ContentEditable>
        <Button v-if='content.cta.show' :translatedBefore='$t(config.cta.beforeText, "cta.beforeText", this.tag)' :translatedAfter='$t(config.cta.afterText, "cta.afterText", this.tag)' :link='$t(content.cta.link, "cta.link", this.tag)' @edit='onCTAEdit($event)' @change='onCTAChange($event)' :editable='editable' :config='content.cta'></Button>
      </div>
    </div>
    <UIActions v-if='editable' :buttons='buttons' @delete='onDelete' @add='onAdd' @edit='onEdit'></UIActions>
  </div>
</template>
<script>
import UIActions from './UIActions.vue'
import ContentEditable from '../../ContentEditable.vue'
import Button from './Button.vue'
import _ from 'lodash';
import TranslationMixin from '../lib/TranslationMixin'
export default {
  props: {
    'config': {default: ()=>{{}}, type: Object},
    'editable': {default: true, type: Boolean},
    'report': {default: ()=>{{}}, type: Object},
    'response': {default: ()=>{{}}, type: Object},
    'buttons': {default: ()=>{['edit', 'add', 'delete']}, type: Array}
  },
  mixins: [TranslationMixin],
  data () {
    return {
      content: {},
      ready: false
    }
  },
  inject: ['globalTheme'],
  components: {
    UIActions,
    ContentEditable,
    Button
  },
  methods: {
    onEdit () {
      this.$emit('edit', {
        target: this,
        fields: null,
        editorClass: 'GraphicEditPanel'
      })
    },
    onCTAEdit (event) {
      this.$emit('edit', event)
    },
    onCTAChange (event) {
      this.content.cta = JSON.parse(JSON.stringify(event))
    },
    onAdd () {
      this.$emit('add')
    },
    onDelete () {
      this.$emit('delete')
    }
  },
  computed: {
    styleOptions () {
      let themeOptions = {
        backgroundColor: this.computedBackgroundColor
      }
      return themeOptions
    },
    computedBackgroundColor () {
      return this.config.theme.backgroundColor || this.globalTheme.brandColor;
    },
    titleColor () {
      return this.config.theme.titleColor || this.globalTheme.brandTitleColor || null
    },
    textColor () {
      return this.config.theme.textColor || this.globalTheme.brandTextColor || null
    },
    titleFontSize () {
      let size = this.config.theme.titleFontSize || this.globalTheme.titleFontSize || 100
      return size
    },
    textFontSize () {
      let size = this.config.theme.textFontSize || this.globalTheme.textFontSize || 100
      return size
    }
  },
  created () {
    this.content = this.config
    setTimeout(()=>{this.ready = true}, 500)
    this.save = _.debounce(function(){
      if (!this.editable) {
        return
      }
      this.$store.dispatch('saveItem', this.config)
    }, 500)
  },
  watch: {
    content: {
      handler: function(content){
        if (!this.ready){
          this.ready = true
          return
        }
        this.$store.commit('setDirty', true)
        this.save()
      },
      deep: true
    }
  }
}
</script>
<style lang='scss' scoped>
  @import '../../../../scss/components/variables';
  @import '../../../../scss/components/form';
  @import '../scss/report_items';

  .report-item--graphic {
    .image {
      max-width: 100%;
      display: inline-block;
      margin-bottom: 1rem;
    }
    .placeholder {
        min-height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        ion-icon {
          font-size: 80px;
          color: #dedede;
        }
      }
    .cta {
      margin-top: 1.5rem;
    }
    .text {
      flex-direction: row;
      position: relative;
      z-index:1;
      align-items: center;
      justify-content: center;
      .text-container {
        padding-left: 5%;
        padding-right: 0;
      }
      // .image-container {
      //   padding-right: 5%;
      // }
      &.reverse {
        flex-direction: row-reverse;
        // .image-container {
        //   padding-right: 0;
        // }
        .text-container {
          padding-left: 0;
          padding-right: 5%;
        }
      }
      .flex-item {
        flex: 0 0 50%;
      }
    }
    .ui-actions {
      z-index: 2;
    }
  }
</style>